import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PmoShell from "./PmoShell";
import AIPlanDialog from "@/components/AIPlanDialog";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Sparkles, Hammer, ArrowUpRight } from "lucide-react";

export default function PmoAiPlan() {
  const [projects, setProjects] = useState(null);
  const [selId, setSelId] = useState("");
  const [dlgOpen, setDlgOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data)).catch(() => setProjects([]));
  }, []);

  const sel = (projects || []).find((p) => p.id === selId);

  return (
    <PmoShell
      title="AI Plan"
      subtitle="Draft an industry-tailored, best-practice plan with AI — scheduled tasks, dependencies and best-fit assignees from your resource velocity profiles."
      testid="pmo-ai-plan-page"
    >
      {projects === null && <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>}
      {projects !== null && (
        <div className="max-w-xl rounded-2xl border border-border bg-white p-6 space-y-5">
          <div>
            <Label>Which project should the plan go into?</Label>
            <Select value={selId} onValueChange={setSelId}>
              <SelectTrigger className="mt-1.5" data-testid="pmo-ai-plan-project-select">
                <SelectValue placeholder={projects.length ? "Pick a project…" : "No active projects yet"} />
              </SelectTrigger>
              <SelectContent>
                {projects.map((p) => (
                  <SelectItem key={p.id} value={p.id} data-testid={`pmo-ai-plan-project-${p.id}`}>
                    {p.name} ({p.task_count} tasks)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {sel && sel.task_count > 0 && (
              <p className="text-xs text-amber-600 mt-1.5">Heads up — generated tasks are appended to the {sel.task_count} already in this project.</p>
            )}
          </div>
          <Button className="gap-2" disabled={!sel} onClick={() => setDlgOpen(true)} data-testid="pmo-ai-plan-open">
            <Sparkles className="h-4 w-4" /> Open AI plan builder
          </Button>
          <div className="border-t border-border pt-4">
            <button onClick={() => nav("/dashboard?new=1")} className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline" data-testid="pmo-ai-plan-new-project">
              <Hammer className="h-3.5 w-3.5" /> Or build a brand-new project first <ArrowUpRight className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      )}
      {sel && (
        <AIPlanDialog key={sel.id} open={dlgOpen} onOpenChange={setDlgOpen} project={sel}
          onGenerated={() => nav(`/projects/${sel.id}?tab=plan`)} />
      )}
    </PmoShell>
  );
}
